export default "__VITE_ASSET__3c942084__"